import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ComponentStruct } from "../../../common/Interfaces";
import SelectCompany from "./SelectCompany";
import ApplicabilityLevel from "./ApplicabilityLevel";
import NextButton from "../search/NextButton";

export default function Maintenance() {
  const [selectedCompany, setSelectedCompany] =
    useState<ComponentStruct | null>(null);
  const [isProductCompany, setIsProductCompany] = useState<boolean>(true);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  return (
    <>
      <Row>
        <h4>Maintenance</h4>
      </Row>
      <Row>
        <Col xs={6}>
          <SelectCompany
            onSelect={(selectedCompany, isProductCompany) => {
              if (!selectedCompany) {
                setSelectedRadio("");
              }
              setSelectedCompany(selectedCompany);
              setIsProductCompany(isProductCompany);
            }}
          />
        </Col>
        <Col xs={6}>
          <ApplicabilityLevel
            isSelectedCompany={selectedCompany !== null}
            onSelect={(radio) => {
              setSelectedRadio(radio);
            }}
            onSerialNumberChange={(number, validity) => {
              if (validity) {
                setSerialNumber(number);
              } else {
                setSerialNumber("");
              }
            }}
          />
        </Col>
      </Row>

      <NextButton
        selectedCompany={selectedCompany}
        isProductCompany={isProductCompany}
        selectedRadio={selectedRadio}
        serialNumber={serialNumber}
      />
      <hr className="separator" />
    </>
  );
}
